@layer components {
  .verse {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-small);
    padding: var(--space-small);
    border-radius: var(--radius);
    -webkit-user-select: none;
    user-select: none;
    cursor: pointer;

    &::before {
      content: attr(data-id);
      opacity: 0.5;
      min-width: 30px;
    }

    &[aria-pressed="true"] {
      background-color: var(--blue);

      /* Łączy tło sąsiednich zaznaczonych wersetów. */
      + [aria-pressed="true"]::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        transform: translateY(-50%);
        background-color: var(--blue);
        display: block;
        width: 100%;
        height: 20px;
      }
    }
  }

  .text {
    flex: 1;
    min-width: 0;

    mark {
      background-color: transparent;
      color: inherit;
      text-decoration: underline;
      text-decoration-thickness: 1px;
      text-underline-offset: 4px;
    }
  }
}
